// @flow @jsx h

import { h } from 'preact'
import Skew from '../../Skew'
import style from '../index.css'
import Byline from './Byline'
import LeadMedia from './LeadMedia'

import type { Props as BaseProps, Viewport } from '../types'

type Props = BaseProps & {
  viewport: Viewport
}

function Header (props: Props) {
  const { data, mediaBaseUrl, viewport } = props

  const inlineStyle = {}
  const headerSkewBottomInlineStyle = {}

  if (viewport.height > -1) {
    if (viewport.width < 720) {
      inlineStyle.height = `${viewport.height - 150}px`
      headerSkewBottomInlineStyle.top = `${viewport.height - 151}px`
    } else {
      inlineStyle.height = `${viewport.height - 55}px`
      headerSkewBottomInlineStyle.top = `${viewport.height - 55}px`
    }
  }

  return (
    <header className={style.article__header} style={inlineStyle}>
      {data.leadMedia && (
        <LeadMedia
          {...data.leadMedia}
          mediaBaseUrl={mediaBaseUrl}
          viewport={viewport}
        />
      )}

      <div className={style.article__headerCopy}>
        <div
          className={style.article__label}
          dangerouslySetInnerHTML={{ __html: data.label }}
        />
        <h1
          className={style.article__title}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <div
          className={style.article__intro}
          dangerouslySetInnerHTML={{ __html: data.intro }}
        />
        <Byline className={style.article__dateline} persons={data.byline} />
      </div>

      <Skew
        className={style.article__headerSkewBottom}
        position='bottom'
        style={headerSkewBottomInlineStyle}
      />
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/v1/components/Article/Header/index.js